import { render, staticRenderFns } from "./PayrollRequisitionPaper.vue?vue&type=template&id=60ab7d26"
import script from "./PayrollRequisitionPaper.vue?vue&type=script&lang=js"
export * from "./PayrollRequisitionPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports